// extracted by mini-css-extract-plugin
export default {"Wrapper":"PopupWrapper_Wrapper__uaGjD","reloadWrapper":"PopupWrapper_reloadWrapper__pcuiU","Popup":"PopupWrapper_Popup__Hj8M8"};